import useAppMonitor from "@/services/AppMonitor";
import Text from "@/ui/core/Text";
import { Box } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { openUrl } from "@/utils/navigation.util";
import { joinTestIDs } from "@/utils/string.util";

interface TextLinkProps extends ViewWithTestID {
  isUnderlined?: boolean;
  onPress?: () => void;
  text: string;
  url: string;
}

/**
 * A component that renders text as a clickable link to open a URL.
 * It shows visual feedback (underline) when pressed and handles error reporting.
 */
const TextLink = ({
  isUnderlined = false,
  onPress,
  testID,
  text,
  url,
}: TextLinkProps) => {
  const { captureException } = useAppMonitor();

  const handlePress = () => {
    onPress?.();
    void openUrl({
      onError: (error?: Error) => {
        captureException(
          new Error(`Failed to open URL: ${url}`, { cause: error }),
        );
      },
      url,
    });
  };

  return (
    <Box onPress={handlePress} testID={joinTestIDs(testID, "link")}>
      <Text
        color={ColorToken.Primary100}
        testID={joinTestIDs(testID, "text")}
        textDecorationLine={isUnderlined ? "underline" : "none"}
        variant="bodyMedium"
      >
        {text}
      </Text>
    </Box>
  );
};

export type { TextLinkProps };
export default TextLink;
